import { ADDCART, DECREMENT, DELETE, INCRMENT } from "./actionTypes";

export const addToCart = (id, prod) => {
 return {
  type: ADDCART,
  payload: prod,
 };
};
export const incrementCart = (id) => {
 return {
  type: INCRMENT,
  payload: {
   id,
   value: 1,
  },
 };
};
export const decrementCart = (id) => {
 return {
  type: DECREMENT,
  payload: {
   id,
   value: 1,
  },
 };
};
export const deleteCartItem = (id) => {
 return {
  type: DELETE,
  payload: id,
 };
};
